function initSliderMediaButtons(sectionId, autoplay = true, intervalTime = 5000) {
    const sliderSection = document.getElementById(`slider-media-buttons-${sectionId}`);
    if (!sliderSection) return;

    const wrapper = sliderSection.querySelector('.slider-media-buttons__wrapper');
    const slides = Array.from(sliderSection.querySelectorAll('.slider-media-buttons__slide'));
    const prevButton = sliderSection.querySelector('.slider-media-buttons__prev');
    const nextButton = sliderSection.querySelector('.slider-media-buttons__next');
    const paginationContainer = sliderSection.querySelector('.slider-media-buttons__pagination');

    let currentIndex = 1;
    let isTransitioning = false;
    let autoplayInterval;
    let isInitialized = false;

    // Variables para touch/swipe optimizadas
    let touchStartX = 0;
    let touchCurrentX = 0;
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isDragging = false;
    let startTransform = 0;
    let isVerticalScroll = false;
    let touchStartTime = 0;
    let animationFrame = null;

    // Configuración de sensibilidad
    const SWIPE_THRESHOLD = 0.2; // 20% del ancho para activar cambio
    const QUICK_SWIPE_THRESHOLD = 30; // píxeles mínimos para swipe rápido
    const QUICK_SWIPE_TIME = 300; // ms máximo para considerar swipe rápido
    const VERTICAL_SCROLL_THRESHOLD = 15; // píxeles para detectar scroll vertical
    const SNAP_THRESHOLD = 0.5; // 50% para decidir a qué slide ir

    // Preparar el wrapper ANTES de cualquier manipulación
    wrapper.style.transition = 'none';
    wrapper.style.willChange = 'transform';
    wrapper.style.transform = 'translateX(0%)'; // Posición inicial temporal
    
    // Ocultar temporalmente para evitar flash
    const originalVisibility = wrapper.style.visibility;
    wrapper.style.visibility = 'hidden';

    // Clonar slides para efecto infinito
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    wrapper.appendChild(firstClone);
    wrapper.insertBefore(lastClone, slides[0]);

    const allSlides = wrapper.querySelectorAll('.slider-media-buttons__slide');
    const totalSlides = allSlides.length;

    function updateSlider(transition = true) {
        if (isInitialized && transition) {
            wrapper.style.transition = 'transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        } else {
            wrapper.style.transition = 'none';
        }
        wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
        updatePagination();
    }

    function updatePagination() {
        paginationContainer.innerHTML = '';
        slides.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.classList.add('pagination-dot');
            if (index === currentIndex - 1) dot.classList.add('active');
            dot.addEventListener('click', () => {
                if (isTransitioning || isDragging) return;
                currentIndex = index + 1;
                updateSlider();
                resetAutoplay();
            });
            paginationContainer.appendChild(dot);
        });
    }

    function goToNextSlide() {
        if (isTransitioning || isDragging) return;
        isTransitioning = true;
        currentIndex++;
        updateSlider();
        wrapper.addEventListener('transitionend', handleTransitionEnd, { once: true });
    }

    function goToPrevSlide() {
        if (isTransitioning || isDragging) return;
        isTransitioning = true;
        currentIndex--;
        updateSlider();
        wrapper.addEventListener('transitionend', handleTransitionEnd, { once: true });
    }

    function handleTransitionEnd() {
        if (allSlides[currentIndex] && allSlides[currentIndex].classList.contains('clone')) {
            currentIndex = currentIndex === totalSlides - 1 ? 1 : totalSlides - 2;
            updateSlider(false);
        }
        isTransitioning = false;
    }

    function startAutoplay() {
        if (autoplay && !isDragging && isInitialized) {
            autoplayInterval = setInterval(goToNextSlide, intervalTime);
        }
    }

    function stopAutoplay() {
        clearInterval(autoplayInterval);
    }

    function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
    }

    function determineTargetSlide(currentTransformPercent, deltaX, isQuickSwipe) {
        const currentPosition = -currentTransformPercent / 100;
        
        if (isQuickSwipe) {
            if (deltaX > 0) {
                return Math.floor(currentPosition);
            } else {
                return Math.ceil(currentPosition);
            }
        }
        
        const fractionalPart = currentPosition - Math.floor(currentPosition);
        
        if (fractionalPart >= SNAP_THRESHOLD) {
            return Math.ceil(currentPosition);
        } else {
            return Math.floor(currentPosition);
        }
    }

    function updateTransformDuringDrag(deltaX) {
        if (animationFrame) {
            cancelAnimationFrame(animationFrame);
        }
        
        animationFrame = requestAnimationFrame(() => {
            const slideWidth = wrapper.offsetWidth;
            const movePercentage = (deltaX / slideWidth) * 100;
            let newTransform = startTransform + movePercentage;
            
            const maxTransform = -(totalSlides - 1) * 100;
            const minTransform = 0;
            
            if (newTransform > minTransform) {
                const excess = newTransform - minTransform;
                newTransform = minTransform + excess * 0.3;
            } else if (newTransform < maxTransform) {
                const excess = newTransform - maxTransform;
                newTransform = maxTransform + excess * 0.3;
            }
            
            wrapper.style.transform = `translateX(${newTransform}%)`;
        });
    }

    function handleTouchStart(e) {
        if (isTransitioning) return;
        
        const touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchCurrentX = touchStartX;
        touchCurrentY = touchStartY;
        touchStartTime = Date.now();
        isDragging = false;
        isVerticalScroll = false;
        
        const currentTransform = wrapper.style.transform;
        const match = currentTransform.match(/translateX\((-?\d+(?:\.\d+)?)%\)/);
        startTransform = match ? parseFloat(match[1]) : -currentIndex * 100;
        
        stopAutoplay();
        wrapper.style.transition = 'none';
    }

    function handleTouchMove(e) {
        if (isTransitioning) return;
        
        const touch = e.touches[0];
        touchCurrentX = touch.clientX;
        touchCurrentY = touch.clientY;
        
        const deltaX = touchCurrentX - touchStartX;
        const deltaY = touchCurrentY - touchStartY;
        
        if (!isDragging && !isVerticalScroll) {
            if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > VERTICAL_SCROLL_THRESHOLD) {
                isVerticalScroll = true;
                return;
            } else if (Math.abs(deltaX) > VERTICAL_SCROLL_THRESHOLD) {
                isDragging = true;
            }
        }
        
        if (isDragging && !isVerticalScroll) {
            e.preventDefault();
            updateTransformDuringDrag(deltaX);
        }
    }

    function handleTouchEnd(e) {
        if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
        }
        
        if (isTransitioning || isVerticalScroll) {
            isVerticalScroll = false;
            resetAutoplay();
            return;
        }
        
        if (!isDragging) {
            resetAutoplay();
            return;
        }
        
        const currentTransform = wrapper.style.transform;
        const match = currentTransform.match(/translateX\((-?\d+(?:\.\d+)?)%\)/);
        const currentTransformPercent = match ? parseFloat(match[1]) : startTransform;
        
        const deltaX = touchCurrentX - touchStartX;
        const slideWidth = wrapper.offsetWidth;
        const threshold = slideWidth * SWIPE_THRESHOLD;
        const touchDuration = Date.now() - touchStartTime;
        const isQuickSwipe = touchDuration < QUICK_SWIPE_TIME && Math.abs(deltaX) > QUICK_SWIPE_THRESHOLD;
        
        wrapper.style.transition = 'transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        
        let targetIndex;
        
        if (Math.abs(deltaX) > threshold || isQuickSwipe) {
            if (deltaX > 0) {
                targetIndex = currentIndex - 1;
            } else {
                targetIndex = currentIndex + 1;
            }
        } else {
            targetIndex = determineTargetSlide(currentTransformPercent, deltaX, isQuickSwipe);
        }
        
        targetIndex = Math.max(0, Math.min(targetIndex, totalSlides - 1));
        currentIndex = targetIndex;
        
        updateSlider();
        
        if (allSlides[currentIndex] && allSlides[currentIndex].classList.contains('clone')) {
            wrapper.addEventListener('transitionend', () => {
                currentIndex = currentIndex === totalSlides - 1 ? 1 : totalSlides - 2;
                updateSlider(false);
            }, { once: true });
        }
        
        isDragging = false;
        isVerticalScroll = false;
        resetAutoplay();
    }

    // Event listeners para botones
    let buttonClickTimeout = null;
    
    nextButton.addEventListener('click', () => {
        if (buttonClickTimeout || isDragging) return;
        buttonClickTimeout = setTimeout(() => {
            buttonClickTimeout = null;
        }, 100);
        
        goToNextSlide();
        resetAutoplay();
    });

    prevButton.addEventListener('click', () => {
        if (buttonClickTimeout || isDragging) return;
        buttonClickTimeout = setTimeout(() => {
            buttonClickTimeout = null;
        }, 100);
        
        goToPrevSlide();
        resetAutoplay();
    });

    // Event listeners para mouse hover
    sliderSection.addEventListener('mouseenter', stopAutoplay);
    sliderSection.addEventListener('mouseleave', startAutoplay);
    
    // Event listeners para touch
    wrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
    wrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
    wrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
    
    // Prevenir comportamientos no deseados
    wrapper.addEventListener('dragstart', (e) => e.preventDefault());
    wrapper.addEventListener('selectstart', (e) => e.preventDefault());
    
    // Manejar cambios de orientación
    window.addEventListener('orientationchange', () => {
        setTimeout(() => {
            updateSlider(false);
        }, 100);
    });
    
    // Cleanup
    window.addEventListener('beforeunload', () => {
        stopAutoplay();
        if (animationFrame) {
            cancelAnimationFrame(animationFrame);
        }
    });
    
    // Inicialización suave y sin flash
    function initializeSlider() {
        // Forzar reflow para asegurar que el DOM esté listo
        wrapper.offsetHeight;
        
        // Establecer posición inicial sin transición
        wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
        
        // Actualizar paginación
        updatePagination();
        
        // Mostrar el slider después de posicionarlo correctamente
        wrapper.style.visibility = originalVisibility || 'visible';
        
        // Usar doble requestAnimationFrame para asegurar que el render esté completo
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                isInitialized = true;
                // Habilitar transiciones para futuras interacciones
                wrapper.style.transition = 'transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
                startAutoplay();
            });
        });
    }
    
    // Inicializar de manera segura
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSlider);
    } else {
        // Si el DOM ya está cargado, usar setTimeout para evitar problemas de timing
        setTimeout(initializeSlider, 0);
    }
}

